import { useTranslation } from "../../next-i18next";
export var useMultiLingualSupportData = function () {
    var t = useTranslation().t;
    return {
        helpLine1: t("helpLine1"),
        helpLine2: t("helpLine2"),
        helpEmail: t("helpEmail"),
    };
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlTXVsdGlMaW5ndWFsU3VwcG9ydERhdGEuanN4Iiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsidXNlTXVsdGlMaW5ndWFsU3VwcG9ydERhdGEudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxjQUFjLEVBQUUsTUFBTSxvQkFBb0IsQ0FBQztBQUVwRCxNQUFNLENBQUMsSUFBTSwwQkFBMEIsR0FBRztJQUNoQyxJQUFBLENBQUMsR0FBSyxjQUFjLEVBQUUsRUFBckIsQ0FBc0I7SUFDL0IsT0FBTztRQUNMLFNBQVMsRUFBRSxDQUFDLENBQUMsV0FBVyxDQUFDO1FBQ3pCLFNBQVMsRUFBRSxDQUFDLENBQUMsV0FBVyxDQUFDO1FBQ3pCLFNBQVMsRUFBRSxDQUFDLENBQUMsV0FBVyxDQUFDO0tBQzFCLENBQUM7QUFDSixDQUFDLENBQUMifQ==